import { render } from "./roomingList.vue?vue&type=template&id=63186ddb&scoped=true"
import script from "./roomingList.vue?vue&type=script&lang=js"
export * from "./roomingList.vue?vue&type=script&lang=js"

import "./roomingList.vue?vue&type=style&index=0&id=63186ddb&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63186ddb"]])

export default __exports__